import { BasketPage as Basket } from "../../features/impact-shop/basket-page/basket-page";
import { GetServerSideProps } from "next";
import auth0, { getAuth0AccessToken } from "../../lib/auth0";
import { withLogging } from "../../lib/ssr/logGetServerSideProps";

export default Basket;

export const getServerSideProps: GetServerSideProps = withLogging(
  async ({ req, res }) => {
    const session = await auth0.getSession(req);
    const accessToken = await getAuth0AccessToken(req, res);

    return {
      props: {
        accessToken,
        isLoggedIn: Boolean(session?.user),
        layoutProps: {
          isWhiteBody: true,
          isProfile: true,
          hideHeader: true,
        },
      },
    };
  }
);
